import clsx from 'clsx'
import {FC, PropsWithChildren} from 'react'
import {HeaderProps} from 'react-table'
import {getTableSortKey, useTableSort} from './tableSort'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<any>>
}

const SortableColumnHeader: FC<Props> = ({className, title, tableProps}) => {
  const {sort, order, toggleSort} = useTableSort()
  const sortKey = getTableSortKey(tableProps.column.id, title)
  const isSorted = !!sortKey && sort === sortKey

  const renderSortIcon = () => {
    if (!sortKey) return null

    if (!isSorted) {
      return <i className={'fa fa-sort fs-8 text-gray-400'} />
    }

    return (
      <i
        className={clsx(
          'fs-8 text-primary',
          order === 'desc' ? 'fa fa-sort-down' : 'fa fa-sort-up'
        )}
      />
    )
  }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={className}
      style={sortKey ? {cursor: 'pointer', userSelect: 'none'} : undefined}
      onClick={() => {
        if (!sortKey) return

        toggleSort(sortKey)
      }}
    >
      <span className={'d-inline-flex align-items-center gap-1'}>
        {title}
        {renderSortIcon()}
      </span>
    </th>
  )
}

export {SortableColumnHeader}
export default SortableColumnHeader
